export default [
    {
        id: '@orderConfirm',
        path: '/order-confirm',
        ref: '/',
        onload: function () { return import('./order-confirm'); },
        store: function () { return import('./order-confirm-store'); }
    }
];
